import { useCallback, useEffect, useRef } from "react";

/**
 * Dedicated chat scroll hook that ONLY scrolls to bottom when manually triggered
 * Removes all automatic scrolling behavior - only scrolls when explicitly called
 */
export default function useChatScroll({
  containerRef,
  currentThreadId,
  messages = [],
}) {
  const scrollTimeoutRef = useRef(null);

  const scrollToBottom = useCallback(() => {
    if (!containerRef?.current) {
      return;
    }

    try {
      const container = containerRef.current;

      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }

      container.scrollTop = container.scrollHeight;

      scrollTimeoutRef.current = setTimeout(() => {
        if (container && container.scrollHeight > 0) {
          container.scrollTop = container.scrollHeight;
        }
      }, 50);
    } catch (error) {
      console.warn("Error during scroll to bottom:", error);
    }
  }, [containerRef]);

  // Clean up timeout on unmount
  useEffect(() => {
    return () => {
      if (scrollTimeoutRef.current) {
        clearTimeout(scrollTimeoutRef.current);
      }
    };
  }, []);

  // Return scroll function for manual use only (no automatic scrolling)
  return {
    scrollToBottom,
  };
}
